import { Component, OnInit } from '@angular/core';
import { COMMON_CONSTANTS } from 'src/app/common/core/common.constants';
import { UtilsService } from 'src/app/services/utils.service';
import { isNullOrUndefined } from 'src/app/services/utils';
import {PnpClientService} from '../../../../pnpframework/lib/services/pnp-client.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  authoringContentData: any;
  currentYear = new Date().getFullYear();
  isRunningInGlobalNav: boolean;
  constructor(private utilsSvc: UtilsService, private _pnpClientService: PnpClientService) { }

  ngOnInit() {
    this.authoringContentData = this.utilsSvc.getContentDataFromSession();
    this.isRunningInGlobalNav = this._pnpClientService.isRunningInGlobalNav();
    if (!isNullOrUndefined(this.authoringContentData) && !isNullOrUndefined(this.authoringContentData.footer)) {
      this.authoringContentData.footer.tmobileIncTxt = this.authoringContentData.footer.tmobileIncTxt.replace('{{currentYear}}', this.currentYear);
    }
  }

  onDNSNavigate() {
    const domain = !isNullOrUndefined(this.authoringContentData && this.authoringContentData.footer &&
    this.authoringContentData.footer.domainURL) ? this.authoringContentData.footer.domainURL : '';
    let mapForm = document.createElement('form');
    mapForm.target = COMMON_CONSTANTS.DNS_WINDOW;
    mapForm.method = COMMON_CONSTANTS.POST;
    mapForm.action = domain;
    const mapInput = document.createElement('input');​
    mapInput.type = COMMON_CONSTANTS.TEXT_TYPE;​
    mapInput.id = COMMON_CONSTANTS.INPUT_ID;
    mapInput.name = COMMON_CONSTANTS.BRAND_TEXT;​
    mapInput.value = COMMON_CONSTANTS.TFB;
    mapForm.appendChild(mapInput);​
    const mapInput1 = document.createElement('input');​
    //mapInput1.type = COMMON_CONSTANTS.HIDDEN_TEXT;​
    mapInput1.name = COMMON_CONSTANTS.SITE_TEXT;​
    mapInput1.value = COMMON_CONSTANTS.NO_SELL_WEB;
    mapForm.appendChild(mapInput1);​
    const mapInput2 = document.createElement('input');​
    //mapInput2.type = COMMON_CONSTANTS.HIDDEN_TEXT;​
    mapInput2.name = COMMON_CONSTANTS.ORIGINURL_TEXT;​
    mapInput2.value = COMMON_CONSTANTS.ACCOUNT_HUB;
    mapForm.appendChild(mapInput2);​
    document.body.appendChild(mapForm);
    window.open(domain , COMMON_CONSTANTS.DNS_WINDOW, COMMON_CONSTANTS.DNS_STYLE);
    mapForm.submit();
  }

}
